// LightBackedBottomButton.tsx

import React from "react"
import { View } from "react-native"
import { PrimaryButton } from "@/components/buttons/CommonButtons"

interface LightBackedBottomButtonProps {
  title: string
  onPress: () => void
  testID?: string
  loading?: boolean
}

export const LightBackedBottomButton = ({
  title,
  onPress,
  testID,
  loading,
}: LightBackedBottomButtonProps) => {
  return (
    <View className="absolute bottom-0 inset-x-0 bg-off-white pt-6 pb-8">
      <View className="px-6">
        <PrimaryButton
          testID={testID || "light-bottom-button"}
          title={title}
          onPress={onPress}
          loading={loading}
        />
      </View>
    </View>
  )
}
